module.exports = __webpack_public_path__ + "static/media/TitleScreen00.c44cea15.png";